import { render, staticRenderFns } from "./group-item.vue?vue&type=template&id=0af42553&"
import script from "./group-item.vue?vue&type=script&lang=js&"
export * from "./group-item.vue?vue&type=script&lang=js&"
import style0 from "./group-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports